<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Canceled',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'Отменено'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>